
/**
 * 알림 상태 정보
 */
export type GetNotificationById200Status = {
  /** 읽음 상태 */
  isRead: boolean;
};
